export enum ChatType {
  GENERAL = 'general',
  DEEP_RESEARCH = 'deep_research',
  EXISTING_CAR = 'existing_car'
}

export enum ResearchStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  EXPIRED = 'expired'
}

export enum MessageRole {
  USER = 'user',
  ASSISTANT = 'assistant'
}

export interface ToolResult {
  id: string;
  tool_name: string;
  status: 'running' | 'completed' | 'error';
  arguments?: any;
  result?: any;
  result_preview?: string;
  startTime?: Date;
  endTime?: Date;
  message?: string;
}

export interface MessageMetadata {
  type?: string;
  data?: any;
  tool_results?: ToolResult[];
}

export interface StreamingEvent {
  type: 'status' | 'tool_start' | 'tool_complete' | 'response_token' | 'final_response' | 'error' | 'stream_end';
  message: string;
  data?: any;
  tool_name?: string;
}

export interface Message {
  id: string;
  role: MessageRole;
  content: string;
  timestamp: string;
  metadata?: MessageMetadata;
  isError?: boolean;
  isStreaming?: boolean;
  toolResults?: ToolResult[];
}

export interface MessageCreate {
  content: string;
}

export interface DeepResearchRequirements {
  budget?: string;
  usage?: string;
  size?: string;
  features?: string;
  brands?: string;
  timeline?: string;
  priority?: string;
}

export interface ExistingCarRequirements {
  year?: string;
  make?: string;
  model?: string;
  trim?: string;
  vin?: string;
  url?: string;
}

export interface ResearchData {
  status: ResearchStatus;
  currentStep: number;
  totalSteps: number;
  requirements?: any;
}

export interface ChatBase {
  name: string;
  type: ChatType;
}

export interface ChatCreate extends ChatBase {}

export interface ResearchChatCreate {
  type: ChatType;
  requirements: any;
}

export interface Chat extends ChatBase {
  id: string;
  createdAt: string;
  updatedAt: string;
  researchData?: ResearchData;
  messages: Message[];
}

export interface ChatListItem extends ChatBase {
  id: string;
  createdAt: string;
  updatedAt: string;
  researchData?: ResearchData;
  lastMessage?: Message;
}
